export default __webpack_public_path__ + "static/media/brain.06556791.png";